import { CheckCircle, AlertTriangle, XCircle, HelpCircle } from "lucide-react";

const riskConfig = {
  GREEN: {
    label: "Low Risk",
    labelEs: "Bajo Riesgo",
    icon: CheckCircle,
    bgColor: "bg-emerald-50",
    textColor: "text-emerald-700",
    borderColor: "border-emerald-200",
    ringColor: "ring-emerald-600/20",
  },
  YELLOW: {
    label: "Medium Risk",
    labelEs: "Riesgo Medio",
    icon: AlertTriangle,
    bgColor: "bg-amber-50",
    textColor: "text-amber-700",
    borderColor: "border-amber-200",
    ringColor: "ring-amber-600/20",
  },
  RED: {
    label: "High Risk",
    labelEs: "Alto Riesgo",
    icon: XCircle,
    bgColor: "bg-red-50",
    textColor: "text-red-700",
    borderColor: "border-red-200",
    ringColor: "ring-red-600/20",
  },
  UNKNOWN: {
    label: "Unknown",
    labelEs: "Desconocido",
    icon: HelpCircle,
    bgColor: "bg-slate-50",
    textColor: "text-slate-600",
    borderColor: "border-slate-200",
    ringColor: "ring-slate-500/10",
  },
};

export const RiskBadge = ({ risk, size = "md", showLabel = true, spanish = false }) => {
  const config = riskConfig[risk] || riskConfig.UNKNOWN;
  const Icon = config.icon;

  const sizeClasses = {
    sm: "px-2 py-0.5 text-xs",
    md: "px-2.5 py-1 text-sm",
    lg: "px-3 py-1.5 text-base",
  };

  const iconSizes = {
    sm: "w-3 h-3",
    md: "w-4 h-4",
    lg: "w-5 h-5",
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-sm font-medium ring-1 ring-inset ${config.bgColor} ${config.textColor} ${config.ringColor} ${sizeClasses[size]}`}
      data-testid={`risk-badge-${risk?.toLowerCase()}`}
    >
      <Icon className={iconSizes[size]} />
      {showLabel && (spanish ? config.labelEs : config.label)}
    </span>
  );
};

export const RiskIndicator = ({ risk, title, description }) => {
  const config = riskConfig[risk] || riskConfig.UNKNOWN;
  const Icon = config.icon;

  return (
    <div
      className={`flex items-start gap-4 p-4 rounded-sm border ${config.borderColor} ${config.bgColor}`}
      data-testid={`risk-indicator-${risk?.toLowerCase()}`}
    >
      <div className={`p-2 rounded-full ${config.bgColor}`}>
        <Icon className={`w-6 h-6 ${config.textColor}`} />
      </div>
      <div>
        <h4 className={`font-semibold ${config.textColor}`}>{title}</h4>
        {description && <p className="text-sm text-slate-600 mt-1">{description}</p>}
      </div>
    </div>
  );
};

export default RiskBadge;
